var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "15 15 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      background: "#FFFFFF"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/assign",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }), /*#__PURE__*/React.createElement("g", {
    id: "Assign",
    transform: "translate(15.000000, 15.000000)",
    className: "svg-path1",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.38125,9.03763604 C5.55191449,9.04768559 3.89695721,7.95384337 3.18929463,6.26689805 C2.48163206,4.57995274 2.86089796,2.63276713 4.14996339,1.33473742 C5.43902881,0.0367076975 7.38353938,-0.356042948 9.07534823,0.339912232 C10.7671571,1.03586741 11.8724418,2.68320471 11.875,4.51256642 C11.875,6.99950172 9.868126,9.02039146 7.38125,9.03763604 L7.38125,9.03763604 Z M7.38125,1.03756642 C5.45860871,1.03756642 3.9,2.59617514 3.9,4.51881642 C3.9,6.44145771 5.45860871,8.00006642 7.38125,8.00006642 C9.30389129,8.00006642 10.8625,6.44145771 10.8625,4.51881642 C10.8625,3.59553152 10.4957265,2.71006196 9.84286548,2.05720094 C9.19000446,1.40433992 8.30453491,1.03756642 7.38125,1.03756642 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.04375,16.5125664 L0,16.5125664 L0,15.3750664 C0.0195825295,12.0510803 2.25857359,9.1502481 5.46916651,8.28922545 C8.67975943,7.4282028 12.0698029,8.81943034 13.75,11.6875664 L12.84375,12.2063164 C11.3985205,9.74917015 8.49058617,8.55933735 5.73746688,9.29865487 C2.98434759,10.0379724 1.06365008,12.524477 1.04375,15.3750664 L1.04375,16.5125664 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 14.60625,
    y: 10.2563164,
    width: 1.04375,
    height: 9.7375
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 10.2625,
    y: 14.6000664,
    width: 9.7375,
    height: 1.04375
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssign);
export default __webpack_public_path__ + "static/media/assign.a960e7d727ce7b37f04ca20c7ebe0b6e.svg";
export { ForwardRef as ReactComponent };